module.exports = __webpack_public_path__ + "fonts/ae835481b4300f36a359012ca7ca11d3.txt";